module.exports = __webpack_public_path__ + "static/media/booked_active.dcea4cc7.svg";